// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/circle-stop.js';

import { paths } from '../generated/circle-stop';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('circle-stop', Original, paths);
